module.exports = __webpack_public_path__ + "static/media/JF Color Logomark.be0d8bc6.png";